module.exports = __webpack_public_path__ + "static/media/suite5.c69322bb.png";